import React, {Fragment, useEffect, useState} from "react";

export default ({dateTime}) => {

    const [days, setDays] = useState(0);
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);

    let timer = null;


    useEffect(() => {

        calculate();
        timer = window.setInterval(calculate, 1000);

        return () => {
            if (timer) {
                window.clearInterval(timer)
            }
        }

    }, []);

    const calculate = () => {

        const to = new Date(dateTime);
        const now = new Date();

        let diff = to.getTime() - now.getTime();

        let d = Math.floor(diff / (24 * 60 * 60 * 1000));
        if (d < 0) {
            d = 0;
        }
        diff -= d * (24 * 60 * 60 * 1000);

        let h = Math.floor(diff / (60 * 60 * 1000));
        diff -= h * (60 * 60 * 1000);

        let m = Math.floor(diff / (60 * 1000));
        diff -= m * (60 * 1000);

        let s = Math.floor(diff / (1000));

        setDays(d);
        setHours(h);
        setMinutes(m);
        setSeconds(s);
    }

    const pad = (number) => {
        if (number < 10) {
            return '0' + number;
        }
        return number;
    }

    return <div className={'countdown__item__holder'}>
        <div className={'countdown__item__cell'}>
            <div className={'countdown__item__cell-inner'}>
                <h4>Days</h4>
                <div className={'countdown__item__counter'}>
                    <div className={'countdown__item__counter-inner'}>
                        <h5>{pad(days)}</h5>
                        <svg viewBox="0 0 36 36">
                            <path
                                className={'line'}
                                d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"
                                fill="none"
                                stroke="#444"
                                strokeWidth="0.2"
                            />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div className={'countdown__item__cell'}>
            <div className={'countdown__item__cell-inner'}>
                <h4>Hours</h4>
                <div className={'countdown__item__counter'}>
                    <div className={'countdown__item__counter-inner'}>
                        <h5>{pad(hours)}</h5>
                        <svg viewBox="0 0 36 36">
                            <path
                                className={'line'}
                                d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"
                                fill="none"
                                stroke="#444"
                                strokeWidth="0.2"
                            />
                            <path
                                className={'graph'}
                                d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"
                                fill="none"
                                stroke="#444"
                                strokeWidth="1"
                                strokeDasharray={`${((hours) / 23) * 100}, 100`}
                            />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div className={'countdown__item__cell'}>
            <div className={'countdown__item__cell-inner'}>
                <h4>Minutes</h4>
                <div className={'countdown__item__counter'}>
                    <div className={'countdown__item__counter-inner'}>
                        <h5>{pad(minutes)}</h5>
                        <svg viewBox="0 0 36 36">
                            <path
                                className={'line'}
                                d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"
                                fill="none"
                                stroke="#444"
                                strokeWidth="0.2"
                            />
                            <path
                                className={'graph'}
                                d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"
                                fill="none"
                                stroke="#444"
                                strokeWidth="1"
                                strokeDasharray={`${((minutes) / 59) * 100}, 100`}
                            />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div className={'countdown__item__cell'}>
            <div className={'countdown__item__cell-inner'}>
                <h4>Seconds</h4>
                <div className={'countdown__item__counter'}>
                    <div className={'countdown__item__counter-inner'}>
                        <h5>{pad(seconds)}</h5>
                        <svg viewBox="0 0 36 36">
                            <path
                                className={'line'}
                                d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"
                                fill="none"
                                stroke="#444"
                            strokeWidth="0.2"
                            />
                            <path
                                className={'graph'}
                                d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831"
                                fill="none"
                                stroke="#444"
                                strokeWidth="1"
                                strokeDasharray={`${((seconds) / 59) * 100}, 100`}
                            />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>

}

